<template>
    <!--<TextInput class="duration" :readonly="true" type="text" :value="display" />-->
    <span class="duration">{{display}}</span>
</template>

<script>
    import TextInput from './TextInput'

    export default {
        name: 'DurationText',
        components: { TextInput },
        props: {
            duration: { type: Number, default: 0, required: true },
        },
        data() {
            const totalSeconds = Math.trunc((this.duration || 0) / 1000);
            const minutes = Math.trunc(totalSeconds / 60);
            const seconds = Math.trunc((totalSeconds % 60));

            return {
                totalSeconds, minutes, seconds,
                display: minutes + ":" + (seconds < 10 ? "0" : "") + seconds
            }
        },
    }
</script>

<style scoped>
    .duration {
        font-weight: 400;
    }
</style>
